<template>
  <div>
    <Card :title="$t('common.A/B Splitter')">
      <CardSection>
        <BaseNodeProperties
          :node="node"
          :readonly="readonly"
        />
      </CardSection>
    </Card>
  </div>
</template>

<script>
import mixin from './propertiesMixin'

export default {
  mixins: [mixin]
}
</script>
